import React from 'react';
import Background from "./components/Background";
import Info from "./components/Info"

function App() {
  return (
    <div className="App">
      <Background />
      <Info />
    </div>
  );

}

export default App;
